module.exports = __webpack_public_path__ + "static/media/controlled-breathing-large@2x.37cfec17.png";